<select (change)="changeLanguage($event)" title="Language">
  @for (lang of data(); track $index) {
    <option [value]="lang" [selected]="lang === currentLanguage()">
      {{ lang | uppercase }}
    </option>
  }
</select>
